module.exports = __webpack_public_path__ + "img/img-scan-qr.0535fa1b.png";